import store from '../store'

// this.areas.includes(this.$props.project.area)

export function userCanRead () {
	return store.getters.permissions('global').consulterPOF || store.getters.permissions('zone').consulterPOF || store.getters.permissions('country').consulterPOF
}

export function userCanCreate () {
	return store.getters.permissions('global').creerPOF || store.getters.permissions('zone').creerPOF || store.getters.permissions('country').creerPOF
}

export function userCanEdit () {
	return store.getters.permissions('global').editerPOF || store.getters.permissions('zone').editerPOF || store.getters.permissions('country').editerPOF
}

export function userCanRefurb () {
	return store.getters.permissions('global').renoverPOF || store.getters.permissions('zone').renoverPOF || store.getters.permissions('country').renoverPOF
}

export function userCanDelete () {
	return store.getters.permissions('global').supprimerPOF || store.getters.permissions('zone').supprimerPOF || store.getters.permissions('country').supprimerPOF
}

export function userCanDeleteFile () {
	return store.getters.permissions('global').supprimerFichierPOF || store.getters.permissions('zone').supprimerFichierPOF || store.getters.permissions('country').supprimerFichierPOF
}

export function userCanEditSteps () {
	return store.getters.permissions('gestionAdminEtapes')
}

export function userCanEditTimeline () {
	return store.getters.permissions('timelineEditerDates')
}

export function userIsGuest () {
	return userCanRead() && !userCanCreate() && !userCanEdit() && !userCanRefurb() && !userCanDelete() && !userCanDeleteFile()
}

export function userCanCreateDraftWithoutCountry () {
	return store.getters.setting('areasCountries') !== null ? store.getters.setting('areasCountries').length === 0 : false
}

/* export function userIsAdmin () {
	return store.getters.roles.includes('ROLE_SUPER_ADMIN')
} */



// WEBPACK FOOTER //
// ./src/helpers/permissions.js